import { render } from "./or-admin-production.vue?vue&type=template&id=866f010a&scoped=true&bindings={\"options\":\"props\",\"categories\":\"props\",\"deleted\":\"props\",\"selected_category\":\"data\",\"products\":\"options\",\"unsaved\":\"options\",\"add\":\"options\",\"remove\":\"options\",\"up\":\"options\",\"down\":\"options\",\"up_product\":\"options\",\"down_product\":\"options\",\"select\":\"options\",\"get_id\":\"options\"}"
import script from "./or-admin-production.vue?vue&type=script&lang=js"
export * from "./or-admin-production.vue?vue&type=script&lang=js"

import "./or-admin-production.vue?vue&type=style&index=0&id=866f010a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-866f010a"

export default script